module.exports = __webpack_public_path__ + "static/img/ic_itembox_mythic.8c95bf48.svg";